export default {
    label: {
        archivedAt: 'Archived at',
        client: 'Client',
        deliveryMethods: 'Delivery Methods',
        document: 'Document',
        documentExternalId: 'Document External ID',
        legalDeliveryCategories: 'Legal Delivery Categories',
        sender: 'Sender',
        total: 'Total',
        transactionDate: '(Transaction) Date',
    },
    title: 'Issued Document Details',
    viewPdf: 'View PDF',
};
